import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { colors } from '@roku-web-ui/rds-theme';

import styles from './loading.module.scss';

export const Loading = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Use setTimeout to show loading after the delay
    const timeoutId = setTimeout(() => {
      setIsVisible(true);
    }, 500);

    // Cleanup function to clear the timeout if the component unmounts
    return () => clearTimeout(timeoutId);
  }, []);

  return (
    isVisible && (
      <Box className={styles.loadingContainer} data-testid="component-loading">
        <CircularProgress sx={{ color: colors.purple[500] }} />
      </Box>
    )
  );
};
